<template>
  <div class="head">
    <div class="logo">
      <img :src="logo" />
    </div>

    <div class="search-input">
      <input
        :type="searchtype ? 'text' : 'button'"
        placeholder="搜索商品"
        v-model="searchValue"
        @click="routeHandle"
        :style="{ width: searchtype ? '5rem' : '5.8rem' }"
      />
      <button @click="search" v-if="searchtype"></button>
    </div>
    <!-- <div class="scan">
      <button>
        <i></i>
        <p>扫一扫</p>
      </button>
    </div> -->
  </div>
</template>
<script>

const logo = require('@/assets/logo.png')

export default {
  data () {
    return {
      searchValue: '搜索商品',
      searchtype: false,
      logo
    }
  },
  methods: {
    routeHandle () {
      if (!this.searchtype) {
        this.$router.push({
          name: 'Search'
        })
      }
    },
    routeType () {
      this.searchtype = (this.$route.name !== "Home")
    },
    // 设置历史搜索
    setHistory () {
      if (this.searchValue === "") return
      let shistory = localStorage.getItem('shistory')
      let arr = []
      if (shistory !== '' || shistory !== null) {
        arr.push(this.searchValue)
        localStorage.setItem('shistory', arr)
      } else {
        let harr = shistory.split(",")
        if (harr.indexOf(this.searchValue) == -1) {
          harr.unshift(this.search)
          if (harr.length > 10) {
            harr.pop()
            localStorage.setItem("shistory", harr)
          } else {
            localStorage.setItem("shistory", harr)
          }
        }
      }
    },
    search () {
      if (this.$route.name === "Search") {
        this.setHistory()
      }
      this.$router.push({
        path: '/product',
        query: {
          type: 'search',
          keyword: this.searchValue
        }
      })
    },
  },
  created () {
    this.routeType()
  }
}
</script>
<style lang="scss" scoped>
.head {
  font-size: 0.25rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.1rem 0.1rem;
  background: #e8e8e8;
  margin-bottom: 0.2rem;
  .search-input {
    position: relative;
    input {
      // width: 5.5rem;
      height: 0.57rem;
      border-radius: 7px;
      line-height: 0.57rem;
      color: #000000;
      border: none;
      padding-left: 0.3rem;
      padding-right: 0.5rem;
      background: #fff;
      text-align: left;
    }
    button {
      position: absolute;
      right: 2%;
      top: 0;
      background: url("../assets/icon/search.png") no-repeat 50%/100%;
      width: 0.4rem;
      height: 100%;
      background-size: 0.4rem;
      border: none;
      padding: 0;
    }
  }
  .logo {
    width: 1.1rem;
  }
}
</style>